import React from 'react';
import StatusCard, { CSS, BrandLogo, IconUnplug } from './StatusCard';

// A dropped stream used to render as one line of capitalised white text —
// "Disconnected code:1006. Click To Restart" — with the words themselves as the
// only thing to click. It now uses the same card as the password, sign-on and
// unavailable states, with a real button. The close code still matters for
// support, so it moves to the small detail line rather than leading.

// App.js composes the message as `Disconnected code:<n>.` plus the close reason
// when it has one. Split rather than reformatted upstream, so the code survives
// for support while the viewer reads plain words. The older wording ended in
// "Click To Restart"; that is still stripped in case a cached bundle sends it.
const parseDisconnect = (raw) => {
  const text = String(raw || '').trim();
  const code = (text.match(/code:\s*(\d+)/i) || [])[1] || '';
  const reason = text
    .replace(/disconnected\s*code:\s*\d+\.?/i, '')
    .replace(/click to restart\.?/i, '')
    .trim();
  return { code, reason };
};

const DisconnectScreen = ({ disconnectMessage, branding = {} }) => {
  const { code, reason } = parseDisconnect(disconnectMessage);

  return (
    <div
      style={{
        position: 'fixed', inset: 0, width: '100vw', height: '100vh',
        backgroundColor: '#111315', zIndex: 1000000, overflow: 'hidden',
      }}
    >
      <style dangerouslySetInnerHTML={{ __html: CSS }} />
      <BrandLogo branding={branding} />
      <StatusCard
        role="alert"
        icon={<IconUnplug />}
        title="Connection lost"
        subtitle={reason || 'The stream disconnected. Reconnect to carry on watching.'}
        detail={code ? `Close code ${code}` : undefined}
      >
        <div className="spg-form">
          <button
            type="button"
            className="spg-btn"
            autoFocus
            onClick={() => window.location.reload()}
          >
            Reconnect
          </button>
        </div>
      </StatusCard>
    </div>
  );
};

export default DisconnectScreen;
